import React from "react";

export default function Pagination({ itemsPerPage, totalItems, currentPage, setCurrentPage }) {
    if (totalItems <= itemsPerPage) {
        return null;
    }

    const totalPages = Math.ceil(totalItems / itemsPerPage);
    const handlePageChange = (page) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
            const facilityListWrapper = document.querySelector(".facility-list-wrapper");
            if (facilityListWrapper) {
                facilityListWrapper.scrollIntoView({ behavior: "smooth" });
            } else {
                window.scrollTo({ top: 0, behavior: "smooth" });
            }
        }
    };
    const getPageRange = () => {
        const pagesToShow = 6;
        let startPage, endPage;
        if (totalPages - currentPage + 1 <= pagesToShow) {
            endPage = totalPages;
            startPage = Math.max(1, totalPages - pagesToShow + 1);
        } else {
            startPage = Math.max(1, currentPage - Math.floor(pagesToShow / 2));
            endPage = startPage + pagesToShow - 1;
            if (endPage > totalPages) {
                endPage = totalPages;
                startPage = Math.max(1, endPage - pagesToShow + 1);
            }
        }
        return { startPage, endPage };
    };
    const { startPage, endPage } = getPageRange();

    return (
        <div className="toolbar toolbar-items">
            <div className="pages">
                <ul className="items pages-items">
                    {currentPage > 1 && (
                        <>
                            <li className="item pages-item-first">
                                <a 
                                    onClick={() => handlePageChange(1)}
                                    className="action first"
                                    title="Go to First Page"
                                >
                                    <span>Go to First Page</span>
                                </a>
                            </li>
                            <li className="item pages-item-previous">
                                <a 
                                    onClick={() => handlePageChange(currentPage - 1)}
                                    className="action previous"
                                    title="Go to Previous Page"
                                >
                                    <span>Go to Previous Page</span>
                                </a>
                            </li>
                        </>
                    )}
                    {Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i).map((page) => (
                        <li className={`item ${currentPage === page ? 'current' : ''}`} key={page}>
                            {currentPage === page ? (
                                <strong className="page">
                                    <span>{page}</span>
                                </strong>
                            ) : (
                                <a
                                    onClick={() => handlePageChange(page)}
                                    className="page"
                                    title={page}
                                >
                                    <span>{page}</span>
                                </a>
                            )}
                        </li>
                    ))}
                    {endPage < totalPages && (
                        <>
                            <li className="item">
                                <span className="no-page">...</span>
                            </li>
                            <li className={`item ${currentPage === totalPages ? 'current' : ''}`} key={totalPages}>
                                {currentPage === totalPages ? (
                                    <strong className="page">
                                        <span>{totalPages}</span>
                                    </strong>
                                ) : (
                                    <a
                                        onClick={() => handlePageChange(totalPages)}
                                        className="page"
                                        title={totalPages}
                                    >
                                        <span>{totalPages}</span>
                                    </a>
                                )}
                            </li>
                        </>
                    )}
                    {currentPage < totalPages && (
                        <li className="item pages-item-next">
                            <a
                                onClick={() => handlePageChange(currentPage + 1)}
                                className="action next"
                                title="Go to Next Page"
                            >
                                <span>Go to Next Page</span>
                            </a>
                        </li>
                    )}
                </ul>
            </div>
        </div>
    );
}
